import axios from 'axios'
import Util from '@/assets/libs/util'

export default {
  sendJsonAndAudio: async function (jsonData, audioBlob) {
    try {
      const formData = new FormData()

      // Redução da lista para ter apenas o código e o nome do produto
      const leanList = jsonData.groups.flatMap(({ products: p }) => p?.map(({ productCode, productName }) => ({ productCode, productName })))

      // Converter JSON para Blob e adicionar ao FormData
      formData.append('data', JSON.stringify(leanList))

      // Carregar áudio Blob
      formData.append('file', audioBlob, 'audio.mp3')

      const response = await axios.post(Util.getAIdress(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 20 * 1000
      })

      // console.log('Resposta do servidor:', response.data)
      return response.data?.response
    } catch (error) {
      console.error('Erro ao enviar dados:', error)
    }
  },
  postRequest: async function (uri, dataObject = {}, token = null, method = 'post') {
    const backAdress = Util.getBackAdress()
    const url = `${backAdress}/${uri}`

    const requestBody = {
      method: method,
      url,
      data: dataObject,
      timeout: 5 * 60 * 1000
    }

    const reqtoken = token || Util.getLocalVar('SESSION_TOKEN')
    if (reqtoken) {
      requestBody.headers = {
        authorization: reqtoken
      }
    }

    const postReturn = await axios(requestBody)
      .then(successResponse => {
        return (successResponse && successResponse.data) || successResponse
      })
      .catch(axiosResponse => {
        throw axiosResponse
      })

    return postReturn
  }
}
